module.exports = "/_next/static/images/mastercard-e068d753e1e2d04794aaedcb851cab18.svg";